import * as React from "react";
import { forwardRef } from "react";
const SvgChevronSmLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.851 2a1.16 1.16 0 0 1 .828.35 1.2 1.2 0 0 1 0 1.68L6.821 7.947l3.858 3.92a1.2 1.2 0 0 1-.379 1.937 1.16 1.16 0 0 1-1.277-.257l-4.68-4.762a1.2 1.2 0 0 1 0-1.68l4.68-4.762A1.16 1.16 0 0 1 9.851 2" }));
const ForwardRef = forwardRef(SvgChevronSmLeft);
export { ForwardRef as ReactComponent };
